import { routes } from 'routes/routes';
import { usePermissions } from 'permissions';
import { Button, Col, HeartBeatLineIcon, Row, User3LineIcon, UserSecurityLineIcon, message } from 'ui';
import { routes as routesAdmin, useAdminDashboardRedirectMutation } from 'features/admin-dashboard';
import { routes as routesEhr, useEhrPortalRedirectMutation } from 'features/ehr-portal';

type P = {
  userId: string;
};

const ChatUserInfoActions = ({ userId }: P) => {
  const { canViewAdminDashboard, canViewEhrPortal } = usePermissions();
  const { isPending: isRedirectingToAdminDashboard, mutate: redirectToAdminDashboard } =
    useAdminDashboardRedirectMutation();
  const { isPending: isRedirectingToEhrPortal, mutate: redirectToEhrPortal } = useEhrPortalRedirectMutation();

  return (
    <Row gutter={['xs', 0]}>
      <Col flex="1 1 0">
        <Button
          block
          icon={<User3LineIcon size="small" />}
          navigate={{ to: routes.members.detail(userId) }}
          type="vertical"
        >
          Go to profile
        </Button>
      </Col>
      {canViewAdminDashboard({}) ? (
        <Col flex="1 1 0">
          <Button
            block
            icon={<UserSecurityLineIcon size="small" />}
            loading={isRedirectingToAdminDashboard}
            onClick={() => {
              message.info('Redirecting to Admin console');
              redirectToAdminDashboard({ referrer: routesAdmin.user.detail(userId) });
            }}
            type="vertical"
          >
            Admin Console
          </Button>
        </Col>
      ) : null}
      {canViewEhrPortal({}) ? (
        <Col flex="1 1 0">
          <Button
            block
            icon={<HeartBeatLineIcon size="small" />}
            loading={isRedirectingToEhrPortal}
            onClick={() => {
              message.info('Redirecting to EHR Portal');
              redirectToEhrPortal({ referrer: routesEhr.user.detail(userId) });
            }}
            type="vertical"
          >
            EHR Portal
          </Button>
        </Col>
      ) : null}
    </Row>
  );
};

export default ChatUserInfoActions;
